import { parseAndFormatDate } from '@/utils/dateHelper';
import React from 'react';
import { IAuthor } from 'types/cms';

import { AuthorAvatar } from './AuthorAvatar';
import styles from './style.module.scss';

interface IProps {
  author: IAuthor;
  date?: string;
}

export const Author: React.FC<IProps> = ({ author, date }) => {
  return (
    <div className={styles.container}>
      {author.avatar && (
        <AuthorAvatar className={styles.avatar} altText={author.name} avatar={author.avatar} />
      )}
      <div className={styles.introduction}>
        {date && <span className={styles.date}>{parseAndFormatDate(date, 'DD MMMM YYYY')}</span>}
        <span className={styles.name}>Article by {author.name}</span>
        {author.occupation && <span>{author.occupation}</span>}
      </div>
    </div>
  );
};
